import React from "react";
import { Avatar, Box, Grid } from "@mui/material";
import {
  AccountBoxOutlined,
  BadgeOutlined,
  CategoryOutlined,
  EmailOutlined,
  InfoOutlined,
  Phone,
} from "@mui/icons-material";

import { useUserDetail } from "../UserDetailScreen";

import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import InformationTile from "components/Shared/InformationTile";
import Status from "components/Shared/Status";

const UserBasicDetail = () => {
  const { userDetail, loadingUser } = useUserDetail();

  const NAME_INITIAL = userDetail?.name
    ?.split(" ")
    ?.slice(0, 2)
    ?.map((el) => el?.charAt(0)?.toUpperCase())
    ?.join(" ");

  return !loadingUser ? (
    <>
      <Box padding={3}>
        <Grid container spacing={4}>
          <Grid item xs={3}>
            <div className="flex flex-col items-center gap-2">
              <Avatar
                src={userDetail?.avatar?.url}
                sx={{ height: 120, width: 120 }}
              >
                {NAME_INITIAL}
              </Avatar>

              <div className="text-center text-xl font-medium">
                {userDetail?.name}
              </div>
            </div>
          </Grid>

          <Grid item xs={9}>
            <Grid container spacing={4}>
              <Grid item xs={12} />

              <Grid item xs={4}>
                <InformationTile
                  icon={() => <EmailOutlined color="primary" />}
                  title="Email"
                >
                  {userDetail?.email ? (
                    <a
                      href={`mailto:${userDetail?.email}`}
                      className="custom-link"
                    >
                      {userDetail?.email}
                    </a>
                  ) : (
                    "N/A"
                  )}
                </InformationTile>
              </Grid>

              {!!userDetail?.typeRefSource && (
                <Grid item xs={4}>
                  <InformationTile
                    icon={() => <AccountBoxOutlined color="primary" />}
                    title="User"
                    subtitle={userDetail?.typeRefSource}
                  />
                </Grid>
              )}

              <Grid item xs={4}>
                <InformationTile
                  icon={() => <CategoryOutlined color="primary" />}
                  title="Category"
                  subtitle={userDetail?.category}
                />
              </Grid>

              <Grid item xs={4}>
                <InformationTile
                  icon={() => <Phone color="primary" />}
                  title="Phone"
                  subtitle={userDetail?.phone}
                />
              </Grid>

              <Grid item xs={4}>
                <InformationTile
                  icon={() => <BadgeOutlined color="primary" />}
                  title="Designation"
                  subtitle={userDetail?.designation}
                />
              </Grid>

              <Grid item xs={4}>
                <InformationTile
                  icon={() => <InfoOutlined color="primary" />}
                  title="Status"
                >
                  <Status isActive={userDetail?.isActive} />
                </InformationTile>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  ) : (
    <InfoGridSkeleton />
  );
};

export default UserBasicDetail;
